export default "__VITE_ASSET__ebabdd69__"